import _ from "lodash";

export type FormatType = "short" | "long" | "hybrid";

export const formatNumber = (
  num: number,
  type: FormatType = "hybrid",
): string => {
  if (!_.isNumber(num)) return num;
  let formattedNumber = num.toString();
  switch (type) {
    case "short": {
      const shortRanges = [
        {
          divider: 1e3,
          suffix: "K",
        },
        {
          divider: 1e6,
          suffix: "M",
        },
        {
          divider: 1e9,
          suffix: "B",
        },
      ];
      formattedNumber = getNumber(num, shortRanges);
      break;
    }
    case "long":
      formattedNumber = num.toLocaleString();
      break;
    default: //hybrid
      if (num < 100000) {
        return num.toLocaleString();
      }
      return formatNumber(num, "short");
  }
  return formattedNumber;
};

interface Range {
  divider: number;
  suffix: string;
}
const getNumber = (num: number, ranges: Range[]): string => {
  let formattedNumber = num.toString();
  for (let index = ranges.length - 1; index >= 0; index--) {
    if (num >= ranges[index].divider) {
      let quotient = num / ranges[index].divider;

      if (quotient < 10) {
        quotient = Math.floor(quotient * 10) / 10;
      } else {
        quotient = Math.floor(quotient);
      }

      formattedNumber = quotient.toString() + ranges[index].suffix;
      break;
    }
  }

  return formattedNumber;
};
